
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1407_18318)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_1407_18318)","stroke":"#E7F3FF","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5.05 5.05l9.9 9.9M14.95 5.05l-9.9 9.9"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1407_18318"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_1407_18318"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(45 6.586 11.414)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    